export function getWorkspaceSessionIdentity(session) {
  return JSON.stringify({
    authGeneration: session?.authGeneration ?? null,
    branchIds: (session?.branches ?? []).map((branch) => branch.id),
    permissions: session?.permissions ?? [],
    role: session?.role ?? "",
    selectedBranchId: session?.selectedBranchId ?? "",
    sessionId: session?.sessionId ?? "",
    shopId: session?.shopId ?? "",
    userId: session?.userId ?? "",
  });
}
